import { Component, ViewChild } from "@angular/core";
import { VTabComponent } from "@app/directives/_layout/v-tabs/v-tab.component";
import { ApplicationManagerComponent } from "./application/_components/application-manager/application-manager.component";
import './rv-lite.component.scss';

@Component({
    selector: 'rv-lite',
    template: require('./rv-lite.component.html')
})
export class RVLiteComponent {
    selectedTab: VTabComponent;

    @ViewChild("appManager") appManager: ApplicationManagerComponent;

    onTabSelected(tab: VTabComponent): void {
        this.selectedTab = tab;
    }
}
